import React, {ReactNode} from 'react';
import {Form, Formik} from 'formik';
import {useDispatch} from 'react-redux';

import {saveHonorAward} from 'shared/portfolio/actions/honor-awards';
import {validateLength} from 'shared/utils';

export interface HonorAward {
  _id: string;
  description: string;
  issuer: string;
  name: string;
  month: number;
  year: number;

  // not from the API, FE only
  editing?: boolean;
  new?: boolean;
  scrollTo?: boolean;
}

export type HonorAwardForm = Omit<HonorAward, 'month' | 'year'> & {
  month: number | null;
  year: number | null;
};

interface Props {
  initialValues: HonorAwardForm;
  children: ReactNode;
  onSuccess?: () => void;
}

const HonorAwardsFormWrapper = ({initialValues, children, onSuccess}: Props) => {
  const dispatch = useDispatch();

  return (
    <Formik
      initialValues={initialValues}
      validate={({month, year, issuer, name}) => {
        const errors: Partial<Record<keyof HonorAwardForm, string>> = {};
        const validateIssuer = validateLength('Issuer', issuer, 256);
        const validateName = validateLength('Name', name, 256);

        if (month === null || month < 0 || month > 11) {
          errors.month = 'Month is required.';
        }

        if (!year) {
          errors.year = 'Year is required.';
        }

        if (month !== null && year) {
          if (new Date() < new Date(year, month)) {
            errors.year = 'Date must not be in the future.';
          }
        }

        if (!issuer) {
          errors.issuer = 'Issuer is required.';
        } else if (validateIssuer) {
          errors.issuer = validateIssuer;
        }

        if (!name) {
          errors.name = 'Name is required.';
        } else if (validateName) {
          errors.name = validateName;
        }

        return errors;
      }}
      onSubmit={async (values, formik) => {
        try {
          await dispatch(saveHonorAward(values));
          onSuccess?.();
        } catch (errors: $TSFixMe) {
          Object.keys(errors).forEach((field) => {
            if (errors[field]) {
              formik.setFieldError(field, errors[field]);
            }
          });
        }
      }}
    >
      <Form autoComplete="off">{children}</Form>
    </Formik>
  );
};

export default HonorAwardsFormWrapper;
